export const MARKETING_PROJECT_DOMAIN = "marketing.bounce.com"
export const USEBOUNCE_PROJECT_DOMAIN = "bounce.com"
export const LEGACY_DOMAIN = "https://usebounce.com"
export const LEGACY_I18N_DOMAIN = "https://bounce.com"
